module.exports = {
      id: "coaching-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#coaching",
      toString: function () {
        return this.url;
      }
    }